var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.390137,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#90A3BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68548 9.50304C5.44355 9.50304 5.25 9.4439 5.10484 9.32562C4.95968 9.20196 4.87097 9.03799 4.83871 8.83369C4.80645 8.62401 4.83871 8.39014 4.93548 8.13207L5.58065 6.32562C5.66129 6.11057 5.67742 5.93584 5.62903 5.80143C5.58602 5.66702 5.48925 5.59981 5.33871 5.59981C5.22043 5.59981 5.10753 5.64551 5 5.73691C4.89247 5.82293 4.79032 5.95734 4.69355 6.14014L4.54032 6.43046H4.23387L4.41129 6.08369C4.58871 5.74498 4.77688 5.50035 4.97581 5.34981C5.18011 5.19928 5.4086 5.12401 5.66129 5.12401C5.90323 5.12401 6.09677 5.18315 6.24194 5.30143C6.3871 5.41971 6.47581 5.58369 6.50806 5.79336C6.54032 5.99766 6.50538 6.23153 6.40323 6.49498L5.75806 8.30143C5.6828 8.51648 5.66667 8.69121 5.70968 8.82562C5.75269 8.96003 5.85215 9.02723 6.00806 9.02723C6.24462 9.02723 6.45699 8.84713 6.64516 8.48691L6.79839 8.19659H7.1129L6.92742 8.54336C6.75 8.88207 6.56183 9.1267 6.3629 9.27723C6.16935 9.42777 5.94355 9.50304 5.68548 9.50304ZM6.33065 4.32562C6.16935 4.32562 6.03495 4.27455 5.92742 4.17239C5.81989 4.06487 5.76613 3.93315 5.76613 3.77723C5.76613 3.61057 5.82796 3.46809 5.95161 3.34981C6.08065 3.22616 6.23387 3.16433 6.41129 3.16433C6.57258 3.16433 6.7043 3.21809 6.80645 3.32562C6.91398 3.42777 6.96774 3.5568 6.96774 3.71272C6.96774 3.87938 6.90323 4.02455 6.77419 4.1482C6.65054 4.26648 6.50269 4.32562 6.33065 4.32562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.839664ca254361f2b42dfc4ddbf7b732.svg";
export { ForwardRef as ReactComponent };